import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
import AgentFab from './components/AgentFab.vue';
import { useAgentStore } from './stores/agent.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'AgentApp',
  setup(__props) {

const store = useAgentStore();
onMounted(() => store.loadConfig());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AgentFab))
}
}

})